import script from "./SalaryVoucherTemplate.vue?vue&type=script&setup=true&lang=js"
export * from "./SalaryVoucherTemplate.vue?vue&type=script&setup=true&lang=js"

import "./SalaryVoucherTemplate.vue?vue&type=style&index=0&id=ab644df6&lang=less&scoped=true"

import exportComponent from "D:\\cwzl\\cw-net\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ab644df6"]])

export default __exports__